import {
    faBoxOpen,
    faRightLong,
    faTrash,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Button, CardBody, CardHeader } from 'reactstrap';
import LowboyAssignmentStatusIcon from './LowboyAssignmentStatusIcon';
import DragIndicator from './DragIndicator';
import ArcGisLocationDisplay from './ArcGisLocationDisplay';
import moment from 'moment';
import FaqtsLocationDisplay from './FaqtsLocationDisplay';

export default class LowboyRequestCardBody extends React.Component {
    render() {
        const {
            equipmentType,
            showDragIndicator,
            lowboyAssignment,
            equipment,
            lowboyResource,
            removeDisabled,
            onRemoveAssignment,
            lowboyAssignmentId,
            removeAssignmentEnabled,
            onRemoveCargo,
            removeCargoEnabled,
            equipmentLocations,
        } = this.props;

        const equipmentLocation = equipmentLocations.find(
            (el) => el.equipmentId == equipment?.id
        );

        const equipmentArcGisLocation = equipmentLocation?.originArcGisLocation;

        const equipmentFaqtsLocation = equipmentLocation?.originLocation;

        const lowboyResourceArcGisLocation =
            lowboyResource?.destinationArcGisLocation;

        const lowboyResourceFaqtsLocation = lowboyResource?.destinationLocation;

        return (
            <>
                {showDragIndicator && <DragIndicator />}
                <CardBody>
                    <CardHeader className="text-muted light-padding w-100">
                        {equipmentType.description}
                    </CardHeader>
                    <div className="text-muted ml-auto mr-auto w-100"></div>
                    <div className="d-flex m-2 w-100">
                        <div className="mr-2">
                            <LowboyAssignmentStatusIcon
                                lowboyAssignment={lowboyAssignment}
                            />
                        </div>

                        {equipment && (
                            <div>
                                <div>
                                    #{equipment.identifier}{' '}
                                    {equipment.description}
                                </div>
                                <div>
                                    {Boolean(
                                        equipmentArcGisLocation ||
                                        !equipmentFaqtsLocation
                                    ) && (
                                        <ArcGisLocationDisplay
                                            location={equipmentArcGisLocation}
                                        />
                                    )}

                                    {Boolean(
                                        !equipmentArcGisLocation &&
                                        equipmentFaqtsLocation
                                    ) && (
                                        <FaqtsLocationDisplay
                                            location={equipmentFaqtsLocation}
                                        />
                                    )}
                                </div>
                            </div>
                        )}

                        {!equipment && (
                            <div className="w-10 empty-resource-slot align-content-center">
                                <FontAwesomeIcon
                                    icon={faBoxOpen}
                                    className="ml-1"
                                />
                            </div>
                        )}

                        <div className="ml-2 mr-2 align-content-center">
                            <FontAwesomeIcon icon={faRightLong} />
                        </div>
                        <div>
                            <div className="job-name">
                                {lowboyResource.jobName}
                            </div>

                            {lowboyResource.startTime && (
                                <div className="job-start-time text-muted">
                                    Start time:{' '}
                                    {moment(`${lowboyResource.startTime}Z`)
                                        .local()
                                        .format('h:mm A')}
                                </div>
                            )}
                            <div className="job-location">
                                {lowboyResourceArcGisLocation && (
                                    <ArcGisLocationDisplay
                                        location={lowboyResourceArcGisLocation}
                                    />
                                )}

                                {lowboyResourceFaqtsLocation && (
                                    <FaqtsLocationDisplay
                                        location={lowboyResourceFaqtsLocation}
                                    />
                                )}
                            </div>
                        </div>

                        {removeAssignmentEnabled && (
                            <div className="float-right ml-5 mr-2">
                                <Button
                                    color={
                                        removeDisabled ? 'default' : 'danger'
                                    }
                                    outline
                                    title="Remove Employee Assignment"
                                    onClick={onRemoveAssignment.bind(this, {
                                        lowboyAssignmentId,
                                    })}
                                    disabled={removeDisabled}
                                    hidden={removeDisabled || !lowboyAssignment}
                                >
                                    <FontAwesomeIcon icon={faTrash} />
                                </Button>
                            </div>
                        )}

                        {removeCargoEnabled && (
                            <Button
                                type="button"
                                title="Remove Equipment Assignment"
                                onClick={onRemoveCargo.bind(this, {
                                    lowboyAssignmentId: lowboyAssignment.id,
                                })}
                                color="danger"
                                className="mr-2"
                                outline
                            >
                                <FontAwesomeIcon icon={faTrash} />
                            </Button>
                        )}
                    </div>
                </CardBody>
            </>
        );
    }
}
